{
  "headings": {
    "question": "Kysy asumisesta",
    "housingQuestion": "Asumiseen liittyvä kysymys",
    "questionPreview": "Kysymyksen esikatselu",
    "questionDetail": "Kysymyksen tiedot",
    "preview": "Esikatselu",
    "success": "Kysymys"
  },
  "texts": {
    "instructions": "Tarvitsetko apua asumiseen liittyvissä asioissa?\n\nLähetä meille viesti oheisen lomakkeen kautta - otamme sinuun yhteyttä mahdollisimman pian.\n\nKiireellisissä tapauksissa pyydämme ottamaan yhteyttä asiantuntijoihimme Yhteystiedot-sivun kautta.",
    "success": "Kysymys on lähetetty. Vastaamme siihen sähköpostilla.",
    "expectsResponseInstructions": "Haluatko vastauksen palautteeseesi? Jos toivot saavasi vastauksen, mainitsethan siitä viestissäsi. Näin voimme varmistaa, että palaamme asiaan mahdollisimman sujuvasti.",
    "contactDetailsUpdateInstructions": "Voit tarvittaessa päivittää yhteystietosi tässä. Voit muokata niitä myös Omat tiedot -sivun kautta."
  },
  "placeholders": {
    "title": "Otsikko",
    "description": "Kuvaile kysymystäsi tarkemmin"
  },
  "alt": {
    "successIllustration": "Kiitos kuvitus"
  },
  "labels": {
    "title": "Otsikko",
    "description": "Kuvaus",
    "files": "Liitteet",
    "email": "Sähköposti",
    "phoneNumber": "Puhelin",
    "expectsResponse": "Haluan, että minuun otetaan yhteyttä"
  },
  "actions": {
    "back": "Takaisin",
    "resetForm": "Tyhjennä lomake",
    "sendForm": "Lähetä kysymys",
    "preview": "Esikatsele",
    "edit": "Muokkaa",
    "submit": "Lähetä"
  },
  "errors": {
    "submitError": "Virhe kysymyksen lähetyksessä. Jos ongelma jatkuu, ota yhteyttä asiakaspalveluun.",
    "serviceUnavailable": "Kysymyksen luonti ei juuri nyt onnistu. Ole hyvä ja yritä myöhemmin uudelleen.",
    "noQuestionFound": "Kysymystä ei löytynyt.",
    "missingUserPhoneNumber": {
      "title": "Kysymyksen luonti ei valitettavasti onnistu",
      "message": "Jatkaaksesi kysymyksen tekemistä, lisää puhelinnumerosi profiiliisi."
    }
  }
}
